export const EUROPEAN_COUNTRIES = [
  { code: "AT", label: "Austria", phoneCode: "+43" },
  { code: "BE", label: "Belgium", phoneCode: "+32" },
  { code: "BG", label: "Bulgaria", phoneCode: "+359" },
  { code: "HR", label: "Croatia", phoneCode: "+385" },
  { code: "CY", label: "Cyprus", phoneCode: "+357" },
  { code: "CZ", label: "Czech Republic", phoneCode: "+420" },
  { code: "DK", label: "Denmark", phoneCode: "+45" },
  { code: "EE", label: "Estonia", phoneCode: "+372" },
  { code: "FI", label: "Finland", phoneCode: "+358" },
  { code: "FR", label: "France", phoneCode: "+33" },
  { code: "DE", label: "Germany", phoneCode: "+49" },
  { code: "GR", label: "Greece", phoneCode: "+30" },
  { code: "HU", label: "Hungary", phoneCode: "+36" },
  { code: "IE", label: "Ireland", phoneCode: "+353" },
  { code: "IT", label: "Italy", phoneCode: "+39" },
  { code: "LV", label: "Latvia", phoneCode: "+371" },
  { code: "LT", label: "Lithuania", phoneCode: "+370" },
  { code: "LU", label: "Luxembourg", phoneCode: "+352" },
  { code: "MT", label: "Malta", phoneCode: "+356" },
  { code: "NL", label: "Netherlands", phoneCode: "+31" },
  { code: "PL", label: "Poland", phoneCode: "+48" },
  { code: "PT", label: "Portugal", phoneCode: "+351" },
  { code: "RO", label: "Romania", phoneCode: "+40" },
  { code: "SK", label: "Slovakia", phoneCode: "+421" },
  { code: "SI", label: "Slovenia", phoneCode: "+386" },
  { code: "ES", label: "Spain", phoneCode: "+34" },
  { code: "SE", label: "Sweden", phoneCode: "+46" },
  { code: "NO", label: "Norway", phoneCode: "+47" },
  { code: "CH", label: "Switzerland", phoneCode: "+41" },
  { code: "IS", label: "Iceland", phoneCode: "+354" },
  { code: "LI", label: "Liechtenstein", phoneCode: "+423" },
  { code: "UK", label: "United Kingdom", phoneCode: "+44" },
];

export const PROPERTY_PURCHASE_COUNTRIES = [
  { code: "BE", label: "Belgium", phoneCode: "+32" },
  { code: "ES", label: "Spain", phoneCode: "+34" },
];

export function getPhoneCodeByCountry(countryCode) {
  const country = EUROPEAN_COUNTRIES.find((c) => c.code === countryCode);
  return country ? country.phoneCode : "";
}
